// Styles
import { RearPendulumModalGraph } from '@/pages/ReportV2/components/Graphs';
import { IonCol, IonGrid, IonRow } from '@ionic/react';
// Slides
import { SwiperSlide } from 'swiper/react';

import { VerticalSwiper } from '@/components/swiper';

interface ModalProps {
  data: any;
}

export const RearPendulumModalContent = ({ data }: ModalProps) => {
  return (
    <>
      <VerticalSwiper>
        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center' style={{ height: '100%' }}>
              <IonCol className='' size='6' style={{ height: '75%' }}>
                <IonRow className='' style={{ height: '75%' }}>
                  <RearPendulumModalGraph
                    MSwLocation={data.rearPendulum_MidSwing_Left}
                    TOLocation={data.rearPendulum_ToeOff_Left}
                    data={data.rearPendulumGraphData_Left}
                    side={'Left'}
                    stanceData={data.rearPendulumStance_Left}
                  />
                </IonRow>
                <IonRow className=''>
                  <IonCol className='ion-no-padding border_Right ion-text-center' size='6'>
                    <p> &sigma; TO: {data.rearPendulumVariance_ToeOff_Left}</p>
                  </IonCol>
                  <IonCol className='ion-no-padding ion-text-center' size='6'>
                    <p> &sigma; MSw: {data.rearPendulumVariance_MidSwing_Left}</p>
                  </IonCol>
                </IonRow>
              </IonCol>
              <IonCol className='ion-align-items-center' size='6' style={{ height: '75%' }}>
                <IonRow className='' style={{ height: '75%' }}>
                  <RearPendulumModalGraph
                    MSwLocation={data.rearPendulum_MidSwing_Right}
                    TOLocation={data.rearPendulum_ToeOff_Right}
                    data={data.rearPendulumGraphData_Right}
                    side={'Right'}
                    stanceData={data.rearPendulumStance_Right}
                  />
                </IonRow>
                <IonRow className=''>
                  <IonCol className='ion-no-padding border_Right ion-text-center' size='6'>
                    <p> &sigma; TO: {data.rearPendulumVariance_ToeOff_Right}</p>
                  </IonCol>
                  <IonCol className='ion-no-padding ion-text-center' size='6'>
                    <p> &sigma; MSw: {data.rearPendulumVariance_MidSwing_Right}</p>
                  </IonCol>
                </IonRow>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>
      </VerticalSwiper>
    </>
  );
};
